'use client';
import styled, { css } from 'styled-components';

export const GridWrapper = styled.div`
  width: 100%;
  padding: ${props => props.theme.spacing(props.$marginTop)} 0
    ${props => props.theme.spacing(props.$marginBottom)};
  background-color: ${props =>
    props.theme.colors.get(
      props.$backgroundColor,
      props.theme.colors.background.base,
    )};
`;

export const GridContainer = styled.div`
  margin: 0 auto;
  width: ${props => props.$mobileWidth + '%'};
  max-width: ${props => (props.$maxWidth ? props.$maxWidth + 'px' : 'none')};
  display: grid;
  column-gap: ${props =>
    props.$gap.column ? props.theme.spacing(props.$gap.column) : 'unset'};
  row-gap: ${props =>
    props.$gap.row ? props.theme.spacing(props.$gap.row) : 'unset'};
  grid-template-columns: repeat(
    ${props => (props.$mobile ? props.$mobile : 12)},
    1fr
  );

  ${props =>
    props.$tablet &&
    css`
      @media ${props => props.theme.tablet} {
        grid-template-columns: repeat(${props => props.$tablet}, 1fr);
      }
    `}

  ${props =>
    props.$laptop &&
    css`
      @media ${props => props.theme.laptop} {
        grid-template-columns: repeat(${props => props.$laptop}, 1fr);
      }
    `}

    @media ${props => props.theme.laptop} {
    width: ${props => props.$width + '%'};
  }
`;

export const CellContainer = styled.div`
  margin: ${props => props.theme.spacing(...props.$margins)};
  ${props => props.theme.calcGridColumn(props.$mobile)}
  display: ${props => (props.$visibility === 'desktop-only' ? 'none' : 'flex')};
  flex-direction: column;
  justify-content: ${props => (props.$justify ? props.$justify : 'normal')};
  height: 100%;
  gap: ${props => props.theme.spacing(props.$gap)};

  ${props =>
    props.$visibility === 'mobile-only' &&
    css`
      @media ${props => props.theme.laptop} {
        display: none;
      }
    `}

  ${props =>
    props.$visibility === 'desktop-only' &&
    css`
      @media ${props => props.theme.laptop} {
        display: flex;
      }
    `}

  ${props =>
    props.$tablet &&
    css`
      @media ${props => props.theme.tablet} {
        ${props => props.theme.calcGridColumn(props.$tablet)}
      }
    `}

  ${props =>
    props.$laptop &&
    css`
      @media ${props => props.theme.laptop} {
        ${props => props.theme.calcGridColumn(props.$laptop)}
      }
    `}

  justify-self: ${props => props.$position};
`;

export const MediaCellWrapper = styled.div`
  position: relative;
  width: 100%;
  line-height: 0;

  @media ${props => props.theme.laptop} {
    flex: 1;
    min-height: 0;
    height: 100%;
  }

  ${props =>
    props.$rounded &&
    css`
      border-radius: 16px;
      overflow: hidden;
    `}
`;

export const MediaCellMobile = styled.div`
  width: 100%;

  img {
    display: block;
    width: 100%;
    height: auto;
  }

  mux-player {
    &::part(center play button) {
      display: flex;
      min-width: 90px;
      min-height: 90px;
      padding: 22px 22px 22px 24px;
    }
  }

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const MediaCellDesktop = styled.div`
  display: none;
  position: relative;
  width: 100%;
  height: 100%;

  mux-player {
    &::part(center play button) {
      display: flex;
      min-width: 90px;
      min-height: 90px;
      padding: 22px 22px 22px 24px;
    }
  }

  @media ${props => props.theme.laptop} {
    display: block;

    img,
    mux-player {
      width: 100%;
      height: 100% !important;
      object-fit: cover;
    }
  }
`;
